module.exports = {"serverless":"https://api.theplanningtools.com/core","ClientId":"4u1ttlmuuk34coenfv37l7efpv","UserPoolId":"us-east-1_21pzqSuEs","IdentityPoolId":"us-east-1:e7e60cb1-2401-4619-b121-b4d96a2fcadb","region":"us-east-1"}


//////////////////
// WEBPACK FOOTER
// ./src/config/ConfigProd.json
// module id = 397
// module chunks = 0